import { createSlice } from '@reduxjs/toolkit';

const intialState = {
    value: null,
}

const dataSlice4 = createSlice({
    name:'data',
    initialState: intialState,
    reducers: {
        active: (state, action) => {
            state.value = action.payload;
        },
        notActive: (state) => {
            state.value = null;
        }
    },
})

export const { active,notActive } = dataSlice4.actions

export default dataSlice4.reducer